import { render } from "./manage-banners.vue?vue&type=template&id=39c8b7bc"
import script from "./manage-banners.vue?vue&type=script&lang=js"
export * from "./manage-banners.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__